module.exports = __webpack_public_path__ + "static/img/chineselogo.1db3169.png";